var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"insertTokenInstructions"},[_c('p',[_vm._v(" Insira o código enviado para o "),[_vm._v(_vm._s(_vm.contactTypeName))],_c('br'),_c('span',{staticClass:"insertTokenInstructions__contact"},[[_vm._v(_vm._s(_vm.contactValue))]],2),_vm._v(" , para validar sua identidade. ")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }